<template>
    <div class="content-container">
        <div class="header">
            <div class="title">Menu</div>
        </div>        
        <div class="content nopad">            
            <div class="sidebar-menu">
                <ul>
                    <li v-bind:class="selectedStateTopics" v-on:click="$emit('show-content', 'topics'); selectTopics()"><span class="menutext">VIEW TOPICS</span></li>
                    <li v-bind:class="selectedStatePosts" v-on:click="$emit('show-content', 'posts'); selectPosts()"><span class="menutext">VIEW POSTS</span></li>
                    <!--<li v-bind:class="selectedStateMessages" v-on:click="$emit('show-content', 'message'); selectMessages()"><span class="menutext">MESSAGE HISTORY</span></li>
                    <li v-bind:class="selectedStateCAEntries" v-on:click="$emit('show-content', 'ca-entries'); selectCaEntries()"><span class="menutext">VIEW CODE ARCHIVE ENTRIES</span></li>-->
                </ul>
            </div>
        </div>
        <div class="content">
            <!-- <div class="member-quickstats">
                <h3>QuickStats</h3>
                <ul>
                    <li>Join Date: {{ stats.joinDateUTC }}</li>
                    <li>Last Seen: {{ stats.lastSeenDateUTC }}</li>
                    <li>Posts: {{ stats.postCount }}</li>
                    <li>Avg Post/Day: {{ stats.avgPostsPerDay }}</li>
                    <li>Code Archive Entries: {{ stats.codeArchiveEntries }}</li>
                </ul>
            </div> -->
        </div>        
    </div>
</template>

<script>

    export default {

        data() {
            return {
                currentSelection: 'topics'
            }
        },

        computed: {
            selectedStateTopics: function() {
                return this.currentSelection === 'topics' ? 'selected' : null;
            },
            selectedStatePosts: function() {
                return this.currentSelection === 'posts' ? 'selected' : null;
            },
            selectedStateMessages: function() {
                return this.currentSelection === 'messages' ? 'selected' : null;
            },
            selectedStateCAEntries: function() {
                return this.currentSelection === 'caEntries' ? 'selected' : null;
            },
        },

        methods: {
            selectTopics: function() {
                this.currentSelection = "topics";
            },
            selectPosts: function() {
                this.currentSelection = "posts";
            },
            selectMessages: function() {
                this.currentSelection = "messages";
            },
            selectCaEntries: function() {
                this.currentSelection = "caEntries";
            },
        }
    }

</script>